import { useEffect, useState } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

import { useNotification } from "context/NotificationContext";
import templateService from "../../../../../../services/templateService";
import documentService from "../../../../../../services/documentService";

const AddDocument = (props) => {
  const { expedienteId, onAddDocument } = props;
  const [documents, setDocuments] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { showNotification } = useNotification();

  useEffect(() => {
    async function fetchTemplates() {
      try {
        const data = await templateService.getAllTemplates();
        if (Array.isArray(data)) setDocuments(data);
      } catch {
        showNotification("Error al cargar las plantillas", "error");
      }
    }
    fetchTemplates();
  }, [expedienteId]);

  const createDocument = async () => {
    setSubmitting(true);
    try {
      const data = await documentService.createDocument(expedienteId, selectedItem);
      if (data === 200) {
        showNotification("Documento creado correctamente", "success");
        setSelectedItem("");
        if (onAddDocument) onAddDocument();
      } else {
        showNotification(data, "error");
      }
    } catch {
      showNotification("Error al crear el documento", "error");
    } finally {
      setSubmitting(false);
    }
  };

  const renderMenuItem = documents.map((x) => (
    <MenuItem key={x.id} value={x.id}>
      {x.name}
    </MenuItem>
  ));

  return (
    <Card>
      <MDBox position="relative" p={1}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={12}>
            <Accordion
              style={{ boxShadow: "none" }}
              sx={{
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark"
                    ? theme.palette.action.hover
                    : "transparent !important",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <MDTypography display="block" variant="button" fontWeight="regular">
                  Crear documento desde una plantilla
                </MDTypography>
              </AccordionSummary>
              <AccordionDetails>
                <FormControl fullWidth>
                  <InputLabel id="input-label">Documento</InputLabel>
                  <Select
                    labelId="input-label"
                    //   id="select"
                    value={selectedItem}
                    onChange={(e) => {
                      setSelectedItem(e.target.value);
                    }}
                    label="Documento"
                    fullWidth
                    sx={{ height: 44 }}
                  >
                    <MenuItem value="">
                      <em>Ninguno</em>
                    </MenuItem>
                    {renderMenuItem}
                  </Select>
                </FormControl>
              </AccordionDetails>
              <AccordionActions>
                <MDButton variant="gradient" color="success" onClick={createDocument} disabled={submitting}>
                  Crear
                </MDButton>
              </AccordionActions>
            </Accordion>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
};

AddDocument.propTypes = {
  expedienteId: PropTypes.number.isRequired,
  onAddDocument: PropTypes.func,
};

export default AddDocument;
